import { useTheme } from '../context/ThemeContext';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const isDark = theme === 'dark';

  return (
    <div className="theme-toggle">
      <button
        type="button"
        className={`btn-theme ${!isDark ? 'active' : ''}`}
        onClick={() => setTheme('light')}
      >
        ☀️ Светлая
      </button>
      <button
        type="button"
        className={`btn-theme ${isDark ? 'active' : ''}`}
        onClick={() => setTheme('dark')}
      >
        🌙 Тёмная
      </button>
    </div>
  );
}

